<template> 
	<div class="compare-block compare-text-infor">
		<h4 class="title compare-block-title pdx-3">
			<i class="title-icon title-icon3"></i>实力标签</h4>
	<!-- <div class="compare-view-scroll compare-text-infor"> -->
		<table  border="0" cellspacing="0" cellpadding="0"  width="100%">
				<tr class="compare-view">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3">综合实力</h5>
			</td>
			<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
				<span class="pdx-3 oh db">
					<i :key="index" class="fl" v-for="(item,index) in list.data.tagList[0].taglist"> {{item.name}}{{index<(list.data.tagList[0].taglist.length-1)?',':''}}</i>
				</span>
			</td> 
				<td class="a-compare-company"  v-for="(item,index) in  5-compareList.length" :key="index+10">-</td>
		</tr>
		<tr class="compare-view compare-text-infor">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3">技术实力</h5>
			</td>
			<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
				<span class="pdx-3 oh db">
					<i :key="index" class="fl"  v-for="(item,index) in list.data.tagList[1].taglist">{{item.name}}{{index<(list.data.tagList[1].taglist.length-1)?',':''}}</i>
				</span>
			</td> 
			<td class="a-compare-company"  v-for="(item,index) in  5-compareList.length" :key="index+10">-</td>
			</tr>
			<tr class="compare-view compare-text-infor">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3">投资实力</h5>
			</td>
			<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
				<span class="pdx-3 oh db">
					<i :key="index" class="fl"  v-for="(item,index) in list.data.tagList[2].taglist"> {{item.name}}{{index < (list.data.tagList[2].taglist.length-1)?',':''}}</i>
				</span>
			</td> 
				<td class="a-compare-company"  v-for="(item,index) in  5-compareList.length" :key="index+10">-</td>
		</tr>
		<tr class="compare-view compare-text-infor">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3">所属协会</h5>
			</td>
			<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
				<span class="pdx-3 oh db">
					<i :key="index" class="fl curp" @click="routerlinkid('/associationDetail',item.id)"  v-for="(item,index) in list.data.associationList"> {{item.title}}{{index<(list.data.associationList.length-1)?',':''}}</i>
				</span>
				<!-- <span class="pdx-3">{{list.stockCode}}</span> -->
			</td> 
			<td class="a-compare-company"  v-for="(item,index) in  5-compareList.length" :key="index+10">-</td>
		</tr>
 </table>
	<!-- </div> --> 
	</div> 
</template>

<script>
export default {
		name: 'compare-slbq',
		data(){return{ 
			userdata:{},
		}},
		props:{
			compareList:{type:Array},
			refreshNum:{type:Number,default:1}
		},
		methods:{
			
		},
		
}
</script>

<style>
</style>